/* eslint-disable no-magic-numbers */
const {
  VITE_API_ENDPOINT_EBM,
  VITE_API_PORT,
  VITE_API_PASARELA_EBM,
  VITE_API_BACK_NODE,
  VITE_API_PORT_NODE,
  VITE_API_HOST,
  VITE_PORT
} = import.meta.env

const usaBackPublicado = window.location.hostname.includes('market')

const esLocalHost =
  window.location.hostname.includes('localhost') ||
  window.location.host.includes(`10.30.20.214:${VITE_PORT}`)
const protocol = usaBackPublicado ? 'https://' : 'http://'

const preEndpointEBM = usaBackPublicado ? VITE_API_ENDPOINT_EBM : `:${VITE_API_PORT}/api`
const hostFinal = VITE_API_HOST || window.location.hostname

const endpointBackNode = esLocalHost
  ? `${hostFinal}:${VITE_API_PORT_NODE}${VITE_API_BACK_NODE}`
  : window.location.host + VITE_API_BACK_NODE

const loginPort = VITE_API_PORT
  ? VITE_API_PORT[1] === '0'
    ? VITE_API_PORT.slice(2)
    : VITE_API_PORT.slice(1)
  : null

const ebuyLoginHostname = window.location.hostname.includes('market')
  ? `www.${window.location.hostname.slice(7)}`
  : loginPort && `${window.location.hostname}:${loginPort}`

export const API_ENDPOINT_EBM = protocol + hostFinal + preEndpointEBM
export const API_ENDPOINT_EBM_PASARELA = `https://${hostFinal}${VITE_API_PASARELA_EBM}`
export const API_ENDPOINT_BACK_NODE = protocol + endpointBackNode

export const logoutURL = protocol + ebuyLoginHostname
